<template>
  <div id="app">

    <footer>

      <div class="container">
        <div class="row">
          <div class="col-6">
            <img class="mb-2" :src="settings.logos.header_title" alt="" height="40">

          </div>
          <div class="col-6 col-md align-self-end text-right">
            <h5>Ressources</h5>
            <ul class="list-unstyled text-small">
              <li><a target="_blank" href="http://www.sodexo.fr/">Sodexo.fr</a></li>
              <li><a target="_blank" href="https:/www./mieux-lemag.fr/">Mieux-lemag</a></li>
              <li><a target="_blank" href="https://www.mieux-lemag.fr/ressources/">Ressources</a></li>
            </ul>
          </div>
          <div class="col-12 pt-3">
            <p class="text-center text-muted" v-if="$i18n.locale=='fr'">L’utilisation de ce site signifie que vous acceptez les conditions d’utilisation. © {{year}} {{settings.brand.brand_name}}. Tous droits réservés.</p>
            <p class="text-center text-muted" v-if="$i18n.locale=='fr'">Crédit <a target="_blank" href="https://www.okedito.com/?utm_source=sodexo&utm_medium=easy_grader&utm_campaign=quiz_rh">Okédito</a></p>
            <p class="text-center  text-muted" v-if="$i18n.locale=='en'">Use of this website signifies your agreement to the Terms of Use. © {{year}} {{settings.brand.brand_name}}. All Rights Reserved</p>
          </div>
        </div>
      </div>


    </footer>



  </div>
</template>

<script>
export default {
    name: 'AppFooter',

    computed: {

    year: function(){
          return (new Date().getFullYear())
      },
    },

    props: {
      settings: {
        type: Object,
        required: true
      }
    }


}


</script>

<style scoped>


footer {
  border-top: 5px var(--colorSecondary) solid;
  background: var(--colorPrimary);
  padding: 55px 0 60px;
  font-family: 'Nunito', sans-serif;
}

h5 {
  color: #fff;
}

.list-unstyled a {
  color: #ccc;
}

p {
  margin-bottom: 0.5rem;
}

p a {
  color: #99D;
}

p a:hover {
  text-decoration: none;
}

.text-muted {
  color: #AAA !important;
}
</style>



// WEBPACK FOOTER //
// src/components/layout/AppFooter.vue